import { render, staticRenderFns } from "./misPedidos.vue?vue&type=template&id=568daca8&scoped=true&"
import script from "./misPedidos.vue?vue&type=script&lang=js&"
export * from "./misPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568daca8",
  null
  
)

export default component.exports